export { default } from './ProductLink';
